// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_95-0";
export var optionCard = "_95-1";